let lastScrollY = window.scrollY;

document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector(".header-wrapper");
  if (!header) return;

  // Function to update header classes
  function updateHeader() {
    const currentScroll = window.scrollY;

    // Top of page
    if (currentScroll <= 50) {
      header.classList.remove("scrolled", "hidden");
      header.classList.add("top-of-page");
    } 
    // Scrolling down
    else if (currentScroll > lastScrollY) {
      header.classList.add("hidden");
      header.classList.remove("scrolled", "top-of-page");
    } 
    // Scrolling up
    else {
      header.classList.remove("hidden", "top-of-page");
      header.classList.add("scrolled");
    }

    lastScrollY = currentScroll;
  }

  // Run once on load
  updateHeader();

  // Run on scroll
  window.addEventListener("scroll", updateHeader);
});